module.exports = "/virtual-football/img/vdh-progress.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/vdh-progress.png
// module id = 283
// module chunks = 6